"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  ${dir("rtl")`
    transform: scaleX(-1);
  `}
`;
const Share = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M7.182 13.85a2.5 2.5 0 1 1 0-3.699l7.88-4.597a2.5 2.5 0 1 1 .756 1.295l-7.88 4.597a2.508 2.508 0 0 1 0 1.108l7.88 4.597a2.5 2.5 0 1 1-.756 1.295l-7.88-4.597z", children: " " })
] });
var Share_default = Share;
export {
  Share_default as default
};
